import { defineMessages } from 'react-intl';

export default defineMessages({
  startSigning: {
    id: 'components.signContractStep.startSigning',
    defaultMessage: 'Start signing',
  },
});
